import * as React from 'react';
import styled from 'styled-components';

import { ReactComponent as ShieldIcon } from 'src/images/checkmark-shield-icon.svg';

const baseFontSize = 14;
const StyledBannerTestimonial = styled.div`
  position: absolute;
  left: ${23 / baseFontSize}em;
  top: -${150 / baseFontSize}em;
  width: ${535 / baseFontSize}em;
  display: flex;
  flex-direction: row;
  align-items: center;
  opacity: 1;
  font-size: ${baseFontSize}px;
  line-height: 1.1em;
  background: var(--white);
  box-shadow: 0 ${2 / baseFontSize}em ${11 / baseFontSize}em rgba(0, 0, 0, 0.11);
  border-radius: 8px;
  padding: ${8 / baseFontSize}em;
  z-index: 15;
  animation: drop-in-rise-out 10s ease;

  @keyframes drop-in-rise-out {
    0%,
    20% {
      top: -${150 / baseFontSize}em;
    }
    25%,
    90% {
      top: ${16 / baseFontSize}em;
    }
    100% {
      top: -${150 / baseFontSize}em;
    }
  }

  .shield-icon {
    min-width: 16px;
    margin: 0 ${8 / baseFontSize}em 0 0;
    path {
      color: ${({ theme }) => theme.merchantColor};
    }
  }

  @media (max-width: 550px) {
    width: 80%;
  }
`;

const TESTIMONIES = [
  '"Great customer service! Fast payment and resolution." – Jean',
  '"Filed a claim in less than a minute, easy to use." –  George',
  '"Issue was resolved quickly with no fuss!" – Gabrielle',
  '"The protection plan is worth paying for, I had no problems." – Jenn',
  '"I felt well informed throughout the entire claims process." – Will',
];

export const BannerTestimonial = () => {
  const testimony = React.useMemo(() => {
    const idx = Math.floor(Math.random() * TESTIMONIES.length);
    return TESTIMONIES[idx];
  }, []);

  return (
    <StyledBannerTestimonial>
      <ShieldIcon className="shield-icon" />
      <span>{testimony}</span>
    </StyledBannerTestimonial>
  );
};

export default BannerTestimonial;
